import React from "react";
import PopulationEvolution from "./PopulationEvolution";
import UnemploymentRateEvolution from "./UnemploymentRateEvolution";
import PopulationByNationality from "./PopulationByNationality";
import AgePyramidChart from "./AgePyramidChart";
import { locales } from "../../locales";

const Population = ({ data, langId, commune, isDesktop }) => {
  const { population, unemployment, nationalities, agePyramids } = data;
  return (
    <div className="flex flex-col mt-6 wort-medium:mt-0">
      <span className="text-left font-bold mt-5 mb-3 text-22 leading-26 uppercase wort-medium:text-32 wort-medium:leading-38">
        {locales[langId].population}
      </span>
      <hr />
      <div className="mt-8 wort-medium:grid wort-medium:grid-cols-2 wort-medium:gap-7">
        <div className="flex flex-col w-full h-96">
          <span className="text-22 leading-26 text-left font-bold ">
            {locales[langId].populationTitle} {commune}
          </span>
          <span className="text-lg text-left my-3 leading-20">
            {locales[langId].populationDescription}
          </span>
          <div className="mt-5 wort-medium:h-280">
            <PopulationEvolution data={population} />
          </div>
          <span className="text-xs text-black-rgba mt-6">
            {locales[langId].references[3]} | {locales[langId].references[4]}
          </span>
        </div>
        <div className="flex flex-col w-full h-96">
          <span className="text-22 leading-26 text-left font-bold">
            {locales[langId].unemploymentTitle} {commune}
          </span>
          <span className="text-lg text-left my-3 leading-20">
            {locales[langId].unemploymentDescription}
          </span>
          <div className="mt-5 h-[202px] wort-medium:h-280">
            <UnemploymentRateEvolution data={unemployment} langId={langId} />
          </div>
          <span className="text-xs text-black-rgba mt-6">
            {locales[langId].references[3]} | {locales[langId].references[4]}
          </span>
        </div>
        <div className="flex flex-col w-full mt-[53px]">
          <span className="text-22 leading-26 text-left font-bold ">
            {locales[langId].nationalityTitle}
          </span>
          <span className="text-lg text-left my-3 leading-20">
            {locales[langId].nationalityDescription}
          </span>
          <div className="mt-5 h-[382px] wort-medium:h-280">
            <PopulationByNationality
              data={nationalities}
              langId={langId}
              isDesktop={isDesktop}
            />
          </div>
          <span className="text-xs text-black-rgba mt-6">
            {locales[langId].references[3]} | {locales[langId].references[4]}
          </span>
        </div>
        <div className="flex flex-col w-full h-96 mt-[53px]">
          <span className="text-22 leading-26 text-left font-bold ">
            {locales[langId].agePyramidTitle}
          </span>
          <span className="text-lg text-left my-3 leading-20">
            {locales[langId].agePyramidDescription}
          </span>
          <div className="mt-5 wort-medium:h-280">
            <AgePyramidChart data={agePyramids} langId={langId} />
          </div>
          <span className="text-xs text-black-rgba mt-6">
            {locales[langId].references[3]} | {locales[langId].references[4]}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Population;
